<template>
    <div>
        <van-popup v-model="contShow" round position="bottom" closeable :style="{ height: '12rem' }" @closed="closed">
            <div class="agreement_box">
                <div class="agreement_title">
                    <span v-if="type=='1'">出价</span>
                    <span v-if="type=='2'">自由出价</span>
                    <!-- <span v-if="type=='3'">竞拍额度不足</span> -->
                    <span v-if="type=='4'">自由出价</span>
                </div>
                <div v-show="type=='1'">
                    <div class="agreement_jia">
                        下口价：{{company_data.currency}}
                        <input type="text" class="jia" v-model="jia_1" disabled/>
                    </div>
                    <div class="agreement_jia2">
                        <a @click="chujia('2')">自由出价</a>
                    </div>
                </div>
                <div v-show="type=='2'">
                    <div class="agreement_jia">
                        <van-button round type="primary" size="small" @click="jiaFun('jian',edu)" :disabled="jia_2<=xiakoujia">-{{edu}}</van-button>
                        <van-button type="default" size="small" style="border:0px;margin:0px 0.3rem;min-width:4rem;font-size:16px;padding:0px;">{{jia_2}}</van-button>
                        <van-button round type="primary" size="small" @click="jiaFun('jia',edu)">+{{edu}}</van-button>
                    </div>
                    <div class="agreement_jia2">
                        <a @click="chujia('1')">返回出价</a>
                    </div>
                </div>
                <!-- <div v-if="type=='3'">
                    <div class="agreement_ts">
                        <p class="p1">本次出价还需充值保证金 ￥2000</p>
                        <p class="p2">请立即充值以便完成当前出价,您的保证金比例为1:{{paiData.deposit_ratio}}</p>
                    </div>
                </div> -->
                <div class="agreement_bottom">
                    <van-button round type="primary" size="normal" block style="margin-top:0.4rem;" v-if="type=='1'" @click="getChangLian">确认出价</van-button>
                    <van-button round type="primary" size="normal" block style="margin-top:0.4rem;" v-if="type=='2'" @click="getChangLian" :disabled="jia_2<xiakoujia">确认出价</van-button>
                    <!-- <van-button round type="primary" size="normal" block style="margin-top:0.4rem;" v-if="type=='3'">去充值</van-button> -->
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import {changLian} from '@/api/live';//直播间长链推送--出价
export default {
    props:["offerShow","offerType","liveData","yhxx"],
    data() {
        return {
            contShow: this.offerShow, //显示
            type:this.offerType,
            jia_1:0,
            jia_2:0,
            liveDatas:'',//数据
            baseList:'',//基础
            company_data:'',//拍卖机构信息
            paiData:'',//拍品数据
            edu:1,
            xiakoujia:1,
        };
    },
    methods: {
        offerFun(show,type,liveData,data){
            this.contShow=show;
            this.type=type;
            this.liveDatas=liveData;
            this.baseList=liveData.baseList;
            this.company_data=liveData.company_data;
            this.paiData=data;
            this.jia_1=this.paiData.bid_price/100;
            this.jia_2=this.paiData.bid_price/100;
            this.xiakoujia=this.paiData.bid_price/100;
            this.eduFun();
        },
        chujia(type){
            this.type=type;
            this.eduFun();
            /* if(type==1){
                this.jia_1=this.jia_2
            }else if(type==2){
                this.jia_2=this.jia_1
            } */
        },
        closed(){//点击弹框背景--关闭
            this.jia_1=0
            this.jia_2=0
        },
        jiaFun(type,num){
            if(type=='jia'){
                this.jia_2=Number(this.jia_2)+Number(num);
            }else if(type=='jian'){
                this.jia_2=Number(this.jia_2)-Number(num)>0?Number(this.jia_2)-Number(num):0;
            }
            this.eduFun();
        },
        eduFun(){
            var eduNew='1';
            if(Math.floor(this.jia_2)<1000){//出价小于1000
                eduNew='100'
            }else{//出价大于1000
                var edus=Math.floor(this.jia_2).toString().length
                for(var i=0;i<edus-2;i++){
                    eduNew+='0'
                }
            }
            this.edu=Number(eduNew)
        },
        getChangLian() {//长链--出价
            let obj = {
                extra: JSON.stringify({
                    special_id: this.company_data.special_id,
                    //special_status: 0,
                    //bid_type: 0,
                    //auction_status: 0,
                    //ladder: 1,
                    //next_art_id: 0,
                    live_id: Number(this.$route.query.id),
                    art_id: this.paiData.art_id,
                    price: this.type==1?Number(this.jia_1*100):Number(this.jia_2*100),
                    bid_status:2,
                }),
                target: this.liveDatas.chatRoomId,
                mt: 14,
                chatType: 5,
                content: "同步拍",
                source: JSON.stringify({
                    img: this.yhxx.imRoles[0].avatar,
                    key: this.yhxx.imRoles[0].roleKey,
                    nickName: this.yhxx.imRoles[0].username,
                    user: this.yhxx.imRoles[0].uid + "",
                }),
                //source: "{\"img\":\"https:\\\/\\\/img13.artimg.net\\\/passport\\\/avatar\\\/002\\\/370\\\/789\\\/150_150.png?1616641475\",\"key\":\"2370789@toutiao\",\"nickName\":\"迈克尔\",\"user\":\"2370789\"}",
                /* source: this.yhxx, */
                timestamp: Date.parse(new Date()),
            }
            changLian(obj).then((res) => {
                if(res.code==0){//出价成功
                    this.$toast(res.data.msg);
                    this.contShow=false;
                }else if(res.code==-9001){//出价失败，返回最新下口价
                    this.$toast(res.message);
                    this.jia_1=res.data.nextShowPirce
                    this.jia_2=res.data.nextShowPirce
                }else{
                    this.$toast(res.message);
                }
            }).catch(err =>{
                this.$toast(err);
            })
        }, 
    },
};
</script>

<style lang="scss" scoped>
.agreement_box{
    width:100%;
    height:auto;
    padding:0.6rem;
}
.agreement_title{
    width:100%;
    line-height:1.1rem;
    font-size:0.8rem;
    color:#27282D;
    text-align:center;
    font-weight:bold;
    margin-top:0.2rem;
    margin-bottom:0.2rem;
}
.agreement_jia{
    width:100%;
    height:auto;
    text-align:center;
    line-height: 1.8rem;
    margin:0.8rem auto 0.3rem;
    font-size:0.7rem;
    color:#27282D;
}
.jia{
    width:10rem;
    height:1.8rem;
    line-height: 1.8rem;
    border:1px solid #DDDEE3;
    border-radius:1rem;
    text-align:center;
    font-size:0.8rem;
    color:#27282D;
    margin-left:0.2rem;
}
.agreement_jia2{
    width:100%;
    height:1rem;
    text-align:right;
    line-height: 1rem;
    padding:0px 2rem;
    font-size:0.6rem;
}
.agreement_jia2 a{
    text-decoration: underline;
}
.agreement_bottom{
    width:100%;
    padding:0.5rem;
}
.agreement_ts{
    width:100%;
    line-height:1rem;
    text-align:center;
}
.agreement_ts .p1{
    font-size:0.8rem;
    color:#27282D;
    font-weight:bold;
    margin:0.8rem 0rem 0.6rem;
}
.agreement_ts .p2{
    font-size:0.6rem;
    color:#969696;
    margin-bottom:0.6rem;
}
</style>